/* eslint-disable no-console */
import { client } from "."; // ← el cliente oficial de Supabase

export const getUsers = async () => {
  try {
    // Supabase tiene límite de 1000 por defecto, aumentamos a 5000 para traer todos
    const { data, error } = await client.from("usuarios").select("*").order("id", { ascending: false }).limit(5000);

    if (error) throw error;

    if (!data || data.length === 0) {
      return [];
    }

    return data;
  } catch (error) {
    console.error("Error en getUsers:", error);
    return [];
  }
};
